<mat-progress-bar mode="determinate" [value]="currentPassStrength" [color]="color">
</mat-progress-bar>
<p>{{strengthName | translate}}</p>